'use client'

import React from 'react'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const tableData = {
	columns: ['Уровень специалиста', 'Стоимость часа', ''],
	rows: [
		{
			level: '1 уровень: Младший специалист (Junior)',
			priceValue: '5 000',
			priceUnit: '₽/час'
		},
		{
			level: '2 уровень: Специалист (Middle)',
			priceValue: '6 000',
			priceUnit: '₽/час'
		},
		{
			level: '3 уровень: Старший специалист (Senior)',
			priceValue: '7 000',
			priceUnit: '₽/час'
		}
	]
}

const Tariffs: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<section className={styles.section}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
						Тарифы
					</Typography>
					<Typography variant='h2' className={styles.title}>
						Стоимость работ
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.tableWrapper}>
					<table className={styles.table}>
						<thead>
							<tr>
								{tableData.columns.map(column => (
									<th key={column}>
										<Typography variant='p1' color='accent'>
											{column}
										</Typography>
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{tableData.rows.map((row, rowIndex) => (
								<tr key={rowIndex}>
									<td>
										<span className={styles.cellText}>{row.level}</span>
									</td>
									<td>
										<div className={styles.priceCell}>
											<span className={styles.priceValue}>{row.priceValue}</span>
											<span className={styles.priceUnit}>{row.priceUnit}</span>
										</div>
									</td>
									<td>
										<button className={styles.actionButton} onClick={openConsultationModal}>
											<span className={styles.actionButtonText}>Оставить заявку</span>
											<span className={styles.actionButtonIcon}>
												<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
													<path
														d='M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z'
														fill='white'
													/>
												</svg>
											</span>
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</AnimatedSection>
		</section>
	)
}

Tariffs.displayName = 'Tariffs'

export default Tariffs
